// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CHf","horizontal":"CHm-","vertical":"CHnb","small":"CHnd","big":"CHct","container":"CHnf","header":"CHap","bold":"CHnh","lead":"CHnj","visible":"CHk7","advMarker":"CHlx"};